import { Dispatch, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { DataActions } from './actionTypes';
import Dispatcher from './dispatcher';
import selector from './selector';

const useGlobalVariables = () => {
    const dispatch = useDispatch<Dispatch<DataActions>>();
    const dispatcher = useMemo(()=>new Dispatcher(dispatch), [dispatch]);
    const state = useSelector(selector, shallowEqual);

    return { state, dispatcher };
}

export default useGlobalVariables;
